import get from "lodash/get";
import getAdCompleted from "selectors/ads/getAdCompleted";
import getCanPlayAds from "selectors/ads/getCanPlayAds";
import getPlayInitialAd from "selectors/story/getPlayInitialAd";
import { createSelector } from "reselect";

const getDisableAds = (state, ownProps = {}) =>
  typeof ownProps.disableAds === "boolean" ? ownProps.disableAds : false;
const getIsActive = (state, ownProps) => get(ownProps, "active", false);

const getPlayAd = createSelector(
  [getAdCompleted, getCanPlayAds, getDisableAds, getIsActive, getPlayInitialAd],
  (adCompleted, canPlayAds, disableAds, isActive, playInitialAd) =>
    !disableAds && isActive && playInitialAd && canPlayAds && !adCompleted,
);

export default getPlayAd;
